<template>
  <div class="footer" :style="{'height':height}"><slot></slot></div>
</template>

<script>
    export default {
        name: "index",
        props:{
            height:{
                type:String,
                default:'52px'
            }
        }
    }
</script>

<style scoped lang="scss">
  .footer{
    box-sizing: border-box;
    position: relative;
    z-index: 1;
    flex-shrink: 0;
  }
</style>



// WEBPACK FOOTER //
// UI/Footer/index.vue